import { useState, useEffect, useRef } from 'react';

declare global {
  interface Window {
    fbq: (action: string, event: string) => void;
  }
}

export default function FinalCTASection() {
  const headingRef = useRef<HTMLHeadingElement>(null);
  const [isVisible, setIsVisible] = useState(false);

  const handleLineClick = () => {
    if (window.fbq) {
      window.fbq('track', 'Contact');
    }
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true);
          }
        });
      },
      { threshold: 0.2 }
    );

    if (headingRef.current) {
      observer.observe(headingRef.current);
    }

    return () => {
      if (headingRef.current) {
        observer.unobserve(headingRef.current);
      }
    };
  }, []);

  return (
    <section id="trial-form" className="py-12 sm:py-16 md:py-20 px-4 sm:px-6 bg-gradient-to-b from-white to-pink-50">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-8 sm:mb-12">
          <h2 
            ref={headingRef}
            className={`text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800 mb-4 sm:mb-6 transition-all duration-1000 ease-out ${
              isVisible ? 'opacity-100 translate-x-0' : 'opacity-0 -translate-x-12'
            }`}
          >
            無料体験レッスン予約
          </h2>
          <p className="text-base sm:text-lg text-gray-600 leading-relaxed mb-3 sm:mb-4">
            まずは気軽に体験してみませんか?
          </p>
          <p className="text-sm sm:text-base text-gray-600 leading-relaxed">
            体験レッスンでは、実際にスタジオで歌って録音していただけます。(所要時間約1時間)<br />
            あなたの声を使った「歌ってみた動画」もプレゼント!
          </p>
        </div>

        <div className="bg-white p-3 sm:p-6 md:p-8 rounded-2xl sm:rounded-3xl shadow-2xl border-2 border-gray-100">
          <div className="w-full overflow-hidden rounded-lg sm:rounded-xl">
            <iframe
              src="https://docs.google.com/forms/d/e/1FAIpQLSfecaRMep8cDcB7lQM-wdIVmFM_fNNIkIEDSuLcNjCTOywKsQ/viewform?embedded=true"
              width="100%"
              height="1467"
              frameBorder="0"
              marginHeight={0}
              marginWidth={0}
              className="w-full border-0"
              style={{ maxWidth: '100%' }}
              title="無料体験レッスン予約フォーム"
            >
              読み込んでいます…
            </iframe>
          </div>
        </div>

        <div id="line-contact" className="mt-12 sm:mt-14 md:mt-16 bg-gradient-to-r from-green-400 to-green-500 p-6 sm:p-8 md:p-10 rounded-2xl sm:rounded-3xl text-center shadow-2xl">
          <div className="mb-4 sm:mb-6">
            <i className="ri-line-fill text-5xl sm:text-6xl text-white"></i>
          </div>
          <h3 className="text-2xl sm:text-3xl font-bold text-white mb-3 sm:mb-4">
            LINEで気軽に相談
          </h3>
          <p className="text-base sm:text-lg text-white/95 mb-6 sm:mb-8 leading-relaxed">
            「まだ体験は早いかも...」という方も、<br />
            LINEで気軽にご相談ください。質問だけでもOKです!
          </p>
          <a
            href="https://line.me/R/ti/p/@987fxrfi?ts=01081449&oat_content=url"
            target="_blank"
            rel="noopener noreferrer"
            onClick={handleLineClick}
            className="whitespace-nowrap inline-block bg-white hover:bg-gray-50 text-green-500 font-bold text-base sm:text-lg px-8 sm:px-10 md:px-12 py-4 sm:py-5 rounded-full shadow-2xl transition-all duration-300 transform hover:scale-105 cursor-pointer"
          >
            <i className="ri-line-fill text-xl sm:text-2xl mr-2"></i>
            LINEで友だち追加
          </a>
        </div>
      </div>
    </section>
  );
}
